import React, { useState } from 'react';
import { loginUser } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { setCurrentUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Check if username exists first
      if (username !== 'admin' && username !== 'guest') {
        setError('Invalid username. Please use either "admin" or "guest".');
        setLoading(false);
        return;
      }

      // Check for correct password based on username
      if (username === 'admin') {
        if (password !== 'Family@2024') {
          setError('Incorrect password for admin account.');
          setLoading(false);
          return;
        }
        const user = await loginUser('admin@familytree.com', 'Family@2024');
        setCurrentUser(user);
        navigate('/');
      } else if (username === 'guest') {
        if (password !== 'Member@2024') {
          setError('Incorrect password for guest account.');
          setLoading(false);
          return;
        }
        const user = await loginUser('guest@familytree.com', 'Member@2024');
        setCurrentUser(user);
        navigate('/');
      }
    } catch (err: any) {
      setError('Failed to log in: ' + (err.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
      <div className="w-full max-w-sm mx-auto">
        <div className="mb-8">
          {/* Removed sign-in message */}
        </div>
        
        {error && (
          <div 
            style={{
              backgroundColor: '#FFEBEE',
              border: '2px solid #EF5350',
              color: '#D32F2F',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '32px',
              fontWeight: 500,
              fontSize: '0.875rem',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }} 
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="md-text-field">
            <input
              id="username"
              name="username"
              type="text"
              required
              className="w-full"
              placeholder=" "
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <label htmlFor="username">Username</label>
          </div>
          
          <div className="md-text-field">
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              className="w-full"
              placeholder=" "
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label htmlFor="password">Password</label>
          </div>

          <div className="pt-2">
            <button
              type="submit"
              disabled={loading}
              className={`md-button md-button-filled w-full ${loading ? 'opacity-75' : ''}`}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
